/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}
export function isJSON (str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log('error：' + str + '!!!' + e)
      return false
    }
  }
  console.log('It is not a string!')
}
/**
 * 是否是纯数字
 * @param val
 * @returns {boolean}
 */
export function isNumber (val) {
  var regPos = /^\d+$/
  if (regPos.test(val)) {
    return true
  } else {
    return false
  }
}

/**
 * 身份证校验
 * @param idcode
 * @returns {boolean}
 * @constructor
 */
export function IdentityCodeValid (idcode) {
  // 加权因子
  var weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  // 校验码
  var checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

  var code = idcode + ''
  var last = idcode[17]// 最后一位

  var seventeen = code.substring(0, 17)

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr = seventeen.split('')
  var len = arr.length
  var num = 0
  for (var i = 0; i < len; i++) {
    num = num + arr[i] * weightFactor[i]
  }
  // 获取余数
  var resisue = num % 11
  var lastNo = checkCode[resisue]

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcardPatter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0-9][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/

  // 判断格式是否正确
  var format = idcardPatter.test(idcode)

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return !!(last === lastNo && format)
}

/**
 * 判断是否为空
 * @param obj
 * @returns {boolean}
 */
export function isNULL (obj) {
  if (obj == null || obj === '' || obj === 'null' || typeof (obj) === 'undefined') {
    return true
  }
  return false
}

export function CheckPassWord (password) { // 必须为字母加数字且长为8-16
  let str = password
  if (str == null || str.length < 8) {
    return false
  }
  let reg1 = new RegExp(/^[0-9A-Za-z$!@#&*]+$/)
  if (!reg1.test(str)) {
    return false
  }
  let reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
  if (!reg.test(str)) {
    return false
  }
  let reg3 = new RegExp(/(?=.*[A-Z])(?=.*[a-z])/)
  if (!reg3.test(str)) {
    return false
  }
  let reg2 = new RegExp(/[$!@#&*]/);
  if (reg2.test(str)) {
    return true;
  } else {
    return false
  }
}
